import { writable } from 'svelte/store';
import moment from 'moment';
import { track } from 'fbq';

function createStore(){
    const {subscribe, update, set} = writable(localStorage.basket && localStorage.basket != 'undefined' ? (() => {
        let storedData = JSON.parse(localStorage.basket);
        if(storedData.deleveryDate){
            let dd = moment(storedData.deleveryDate)
            if(dd.isBefore(moment(), 'day')){
                storedData.deleveryDate = null;
                storedData.items = [];
            }
        }
        return storedData;
    })() : {
        show: false,
        deleveryDate: null,
        items: [],
        total: 0,
        shipping: {},
        order_id: null
    })

    return {
        subscribe,
        set,
        update,
        add: (item) => {
            track("AddToCart", item);
            update(u => {
                return {...u, items: [...u.items, item]};
            })
        },
        updateItem: (item) => {
            update(u => {
                const items = [...u.items];
                const index = items.findIndex(i => i.item_num == item.item_num);
                if(index > -1){
                    if(items[index].pricelist_by_avl_sizes.reduce((t,c) => t+(c.quantity ? c.quantity : 0), 0) > 0)
                        items[index] = item;
                    else
                        items.splice(index,1);
                    return {...u, items}
                }
            })
        },
        setDate: (date) => {
            update(u => {
                return {...u, deleveryDate: date}
            })
        },
        remove: (item) => {
            update(u => ({...u, items: [...u.items.filter(i => i.sku != item.sku && i.variant != item.variant)]}))
        },
        clear: () => {
            update(u => ({...u, items: []}))
        },
        open: () => {
            update(u => ({...u, show: true}))
        },
        close: () => {
            update(u => ({...u, show: false}))
        }
    }
}

export const Basket = createStore();

Basket.subscribe((value) => localStorage.basket = JSON.stringify(value))